/* eslint-disable import/prefer-default-export */
import COLORS from '$variables/colors';
import { typography, spacing } from '$variables/theme';

export const looks = {
  green: {
    color: COLORS.green,
    backgroundColor: COLORS.greenHighlight,
  },
  purple: {
    color: COLORS.purpleDark,
    backgroundColor: COLORS.purpleHighlight,
  },
  grey: {
    color: COLORS.default,
    backgroundColor: COLORS.grey2,
  },
  lightGrey: {
    color: COLORS.grey3,
    backgroundColor: COLORS.lightGreyBg,
  },
  lightBlue: {
    color: COLORS.shadow6,
    backgroundColor: COLORS.aliceBlue,
  },
  cream: {
    color: COLORS.shadow6,
    backgroundColor: COLORS.warningBg,
  },
  paleRed: {
    color: COLORS.shadow6,
    backgroundColor: COLORS.errorBg,
  },
  lavender: {
    color: COLORS.shadow6,
    backgroundColor: COLORS.lavender,
  },
  upcoming: {
    color: COLORS.grey3,
    backgroundColor: COLORS.shadow,
    borderColor: COLORS.grey7,
  },
};

export const sizes = {
  default: {
    lineHeight: '14px',
    fontSize: '12px',
    fontWeight: typography.fontWeightBold,
    padding: `${spacing.xxSmall} ${spacing.xSmall}`,
  },
  compact: {
    lineHeight: '16px',
    fontSize: '14px',
    fontWeight: typography.fontWeightRegular,
    padding: `${spacing.xxxSmall} ${spacing.xxSmall}`,
  },
};
